import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import Y from '../../y18n'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import TopNavigationAppShell from '../../common/top-navigation-app-shell'
import * as accountActions from '../../store/accounts'
import Styles from '../../common/styles'

const mapStateToProps = state => ({
  accounts: state.accounts,
  locales: state.locales
})

const mapDispatchToProps = dispatch => ({
  accountActions: bindActionCreators(accountActions, dispatch)
})

class RegisteredPage extends Component {
  render () {
    const { classes, locales } = this.props
    return (
      <TopNavigationAppShell
        content={
          <div className={classes.accountContainer}>
            <Link to={'/'}>
              <img src={locales.logo} alt='logo' className={classes.logo} />
            </Link>
            <Paper elevation={3} square style={{ marginTop: '40px' }}>
              <div className={classes.content}>
                <div className={classes.textRow}>
                  <Typography variant='title'>{Y`Thank you for registering!`}</Typography>
                  <Typography variant='body2' className={classes.spacer}>
                    {Y`What happens now?`}
                  </Typography>
                  <Typography variant='body1' className={classes.spacer}>
                    {Y`You will receive an email with a link where you can set a password for your account. Be sure to check the junk mail folder of your email program if you can't find the email in your inbox.`}
                  </Typography>
                  <Typography variant='body1' className={classes.spacer}>
                    {Y`If you don't receive an email from us within 5 minutes please contact our support`}
                    {' '}
                    {locales.country === 'Finland'
                      ? <a href='mailto:support@hyltesim.fi' className={classes.themeLink}>support@hyltesim.fi</a>
                      : <a href='mailto:support@hyltesim.se' className={classes.themeLink}>support@hyltesim.se</a>}
                  </Typography>
                  <Typography variant='body2' className={classes.spacer}>
                    {Y`Thank you!`}
                  </Typography>
                </div>
              </div>
            </Paper>
          </div>
        }
        pageName={'Registered'}
      />
    )
  }
}

RegisteredPage = connect(mapStateToProps, mapDispatchToProps)(RegisteredPage)
export default withStyles(Styles)(RegisteredPage)



// WEBPACK FOOTER //
// ./src/pages/account/registered.js